export default {
  masterChef: {
    4002: '0xB5834d35F784E18Ea6efc8F32A53388e87c998c1',
    1073: '0x4794Aeafa5Efe2fC1F6f5eb745798aaF39A81D3e'
  },
  fairlaunch: {
    4002: '0x9E8A7451cd3E916631d9b0d7941BEf6FE4cABa8e',
  },
  farmZap: {
    4002: "0x2B3A6040B37CCBE4BE31FAdAD8f229859Fc04150",
    1073: '0x12b852f70be1D0d41925DE9fEE1c77FE78255df8'
  },
  multiCall: {
    3: '0x0b4117cF0D344d73d2d0033a9698dFdDbB71aBB0',
    537: '0x86e08E2EAc6004E4D42Ac202Abd4E5a657e798bD',
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
    4002: '0xf8F03c3f1808A4c89620e73585988469C91462Ca',
    1073: '0x394c544205e9A942573bEe7D1B8d9bdfD87f78D0'
  },
  cakeVault: {
    56: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
    97: '',
  },
  chainlinkOracle: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
  },
  priceGetter: {
    4002: '0x502cA80366344f9AE996BCEd8eDB9b06129eA5a8',
    1073: '0x9eD3dF656bE24262440EEbe516F700475040f427'
  },
  router: {
    4002: '0xEBcfAc963dFee6a00E4281C461F49C3317bE9aBB',
    1073: '0x53a8E1b94B9b43f376A167495830b419204e1B06'
  },
  nftMarket: {
    4002: '0x52Ee23731A88ACfC571b1fbc735F68A61fda52F9',
    1073: '',
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  feeManager :{
    4002 :'0x35b42555EC7046D3a7300C28e3Ff316F3eF3Ae3d'
  }

}
